import { useEffect } from 'react';

import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

import RealtimeChannelTable from '../../components/realtime/channels/RealtimeChannelTable';
import RealtimeChannelModal from '../../components/realtime/channels/RealtimeChannelModal';

import { useRealtimeChannels } from '../../hooks/realtime/useRealtimeChannels';

const RealtimeChannelsPage = () => {
  const {
    channels,

    loading,

    selectedChannel,

    channelModalOpen,

    handlerGetChannels,

    openEditModal,

    closeModal,

    handlerUpdateChannel,
  } = useRealtimeChannels();

  useEffect(() => {
    handlerGetChannels();
  }, []);

  const handleSave = async (data: any) => {
    if (!selectedChannel) {
      return;
    }

    await handlerUpdateChannel(selectedChannel.id, data);
  };

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <RealtimeChannelTable
        channels={channels}
        loading={loading}
        onEdit={openEditModal}
      />

      <RealtimeChannelModal
        open={channelModalOpen}
        channel={selectedChannel}
        onClose={closeModal}
        onSave={handleSave}
      />
    </DefaultLayout>
  );
};

export default RealtimeChannelsPage;
